import localforage from "localforage";
import sessionStorageWrapper from 'localforage-sessionstoragewrapper';
const UseLocalForage = true;

class StorageSessionService {
    setSessionStorage = (key, value) => {
        if (UseLocalForage) {
            return localforage.defineDriver(sessionStorageWrapper).then(function () {
                localforage.setDriver(sessionStorageWrapper._driver);
            }).then(function () {
                console.log('Active driver: ' + localforage.driver());
                localforage.setItem(key, value);
            }).then(function () {
                console.log('set item ' + key + ' => success');
            });
        } else {
            return new Promise((resolve, reject) => {
                sessionStorage.setItem(key, value);
                resolve();
            });
        }
    }

    getSessionStorage = (key) => {
        if (UseLocalForage) {
            return localforage.defineDriver(sessionStorageWrapper).then(function () {
                return localforage.setDriver(sessionStorageWrapper._driver);
            }).then(function () {
                console.log('Active driver: ' + localforage.driver());
                return localforage.getItem(key);
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve(sessionStorage.getItem(key));
            });
        }
    }

    removeSessionStorage = (key) => {
        if (UseLocalForage) {
            return localforage.defineDriver(sessionStorageWrapper).then(function () {
                return localforage.setDriver(sessionStorageWrapper._driver);
            }).then(function () {
                console.log('Active driver: ' + localforage.driver());
                return localforage.removeItem(key);
            });
        } else {
            return new Promise((resolve, reject) => {
                resolve(sessionStorage.removeItem(key));
            });
        }
    }
}

export default StorageSessionService;